export const ExtensionActionTypes = {
    API_RESPONSE_SUCCESS: '@@extension/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@extension/API_RESPONSE_ERROR',
    SUBMIT_EXTENSION: '@@extension/SUBMIT_EXTENSION',
    GET_EXTENSION: '@@extension/GET_EXTENSION',
    CONFIRM_EXTENSION: '@@extension/CONFIRM_EXTENSION',
    RETRACT_EXTENSION: '@@extension/RETRACT_EXTENSION',
    RESET_EXTENSION: '@@extension/RESET_EXTENSION',
};
